import { Card, CardContent } from "@/components/ui/card"
import { getImagePath } from "@/lib/helpers/imageHelpers"
import { formatRelativeTime } from "@/lib/utils"
import Image from "next/image"
import Link from "@/components/Link"
import type { BlogListItemProps } from "./types"

export const BlogListItem = ({ data }: BlogListItemProps) => {
	return (
		<Card className="overflow-hidden transition-shadow duration-300 hover:shadow-lg">
			<Link href={`/blog/${data.slug}`}>
				<CardContent className="p-4">
					<div className="flex flex-col gap-4 sm:flex-row">
						<div className="relative mx-auto h-24 w-32 flex-shrink-0 sm:mx-0 sm:h-32 sm:w-48">
							<Image
								className="rounded-lg object-cover"
								src={getImagePath(data, "blog")}
								alt={data.name}
								fill
								sizes="(max-width: 640px) 128px, 192px"
								priority
							/>
						</div>
						<div className="flex-1 space-y-2 text-center sm:space-y-3 sm:text-left">
							<div>
								<h3 className="line-clamp-2 font-semibold text-base transition-colors hover:text-primary sm:text-lg">
									{data.name}
								</h3>
								<p className="mt-1 text-muted-foreground text-xs sm:text-sm">
									{data.user_fullname} •{" "}
									{formatRelativeTime(data.created_at)}
								</p>
							</div>
							<p className="line-clamp-2 text-muted-foreground text-xs sm:text-sm">
								{data.description}
							</p>
							<div className="flex flex-wrap justify-center gap-1.5 sm:justify-start">
								{Array.isArray(data.tag) &&
									data.tag.length > 0 &&
									data?.tag.map((tag: string) => (
										<span
											key={tag}
											className="rounded-full bg-secondary px-2 py-0.5 font-medium text-secondary-foreground text-xs"
										>
											{tag}
										</span>
									))}
							</div>
						</div>
					</div>
				</CardContent>
			</Link>
		</Card>
	)
} 